import sweealert2 from 'sweetalert2'
const msg = {}
msg.install = (Vue) =>{
    Vue.prototype.$msg ={
        question(texto)
        {
            return sweealert2.fire({
                text:texto,
                icon:'warning',
                showCancelButton:true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText:'Si',
                cancelButtonText:'No',
            })
        },
        success(texto){
            return sweealert2.fire({
                text:texto,
                icon:'success',
            })
        },
        warning(texto){
            return sweealert2.fire({
                title:"ChevronCard",
                text:texto,
                icon:'warning',
            })
        },
        error(texto){
            return sweealert2.fire({
                title:"ChevronCard",
                text:texto,
                icon:'error',

            })
        },
        info(texto){
            return sweealert2.fire(
                {
                    title:"ChevronCard",
                    text:texto,
                    icon:'info',
                }
            )
        }
    }
}
export default msg;